
import api from './api';
import session from './session';

class Marketer {

	constructor (Api, Session) {
		this.Api = Api;
		this.Session = Session;
	}

	all () {
		return this.Api.get({
			url:  'v1.1/m/marketers'
		}).then(response => response.marketers.map(marketer => {
			if (marketer.id === undefined) {
				marketer.doNotDisplayActions = true;
			}
			return marketer;
		}));
	}

	me () {
		return this.Api.get({
			url:  'v1.1/m/marketers/me'
		}).then(response => {
			return response;
		});
	}

	get (marketerId) {
		return this.Api.get({
			url:  'v1.1/m/marketers/'+marketerId
		}).then(response => response.marketer);
	}

	delete (marketerId) {
		return this.Api.delete({
			url:  'v1.1/m/marketers/'+marketerId
		}).then(response => response.marketer);
	}

	update (marketerId, marketer) {
		return this.Api.put({
			url:  'v1.1/m/marketers/'+marketerId,
			body: generatePayload(marketer)
		}).then(response => response.marketer);
	}

	create (marketer) {
		return this.Api.post({
			url:  'v1.1/m/marketers',
			body: generatePayload(marketer)
		}).then(response => response.marketer);
	}

	updateNotifications (marketer) {
		return this.Api.put({
			url:  'v1.1/m/marketers/'+marketer.id+'/notifications',
			body: marketer
		}).then(response => {
			this.Session.set('user', marketer);
			return response.marketer;
		});
	}

}

Marketer.$inject = ['Api', 'Session'];

export default angular.module('service.marketer', [api])
	.service('Marketer', Marketer)
	.name;


function generatePayload (marketer) {
	return {
		name:       marketer.name,
		email:      marketer.email,
		password:   marketer.password,
		zones:      (marketer.hasAllZones) ? '*' : marketer.zones.filter(z => z.checked).map(z => z.id),
		stores:     marketer.zones.reduce((acc, zone) => acc.concat(zone.stores.filter(s => s.checked).map(s => s.id)), []),
		publish:    marketer.canPublish ? '1' : '0',
		write:      marketer.canWrite ? '1' : '0',
	};
}



// WEBPACK FOOTER //
// ./src/service/marketer.js